import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    mocks: [
        {
            id: "dummy-mock-1",
            enabled: true,
            type: "api",
            path: "https://api.example.com/data",
            method: "GET",
            pattern_name: "pwa-api-fetchスニペット用サンプル",
            status: 200,
            delayMs: 500,
            response: '[{"id":1,"name":"Apple"},{"id":2,"name":"Banana"},{"id":3,"name":"Cherry"}]'
        }
    ],
    scenarios: [
        {
            id: "dummy-scenario-1",
            name: "サンプルシナリオ",
            description: "画面遷移のテスト",
            code: "import { screen, waitFor } from 'https://esm.sh/@testing-library/dom';\nimport userEvent from 'https://esm.sh/@testing-library/user-event';\nimport { expect } from 'https://esm.sh/chai';\n\nexport default async function runTest() {\n  // ここにテストコードを記述します\n}",
            locked: false
        }
    ],
    executionState: {
        isRunning: false,
        isCancelled: false,
        currentScenarioId: null,
        results: {}
    }
};

const testItemSlice = createSlice({
    name: 'testItem',
    initialState,
    reducers: {
        loadTestData(state, action) {
            if (action.payload) {
                state.mocks = action.payload.mocks || state.mocks;
                state.scenarios = action.payload.scenarios || state.scenarios;
            }
        },
        toggleMockEnabled(state, action) {
            const mock = state.mocks.find(m => m.id === action.payload);
            if (mock) {
                mock.enabled = !mock.enabled;
            }
        },
        setExecutionState(state, action) {
            state.executionState = { ...state.executionState, ...action.payload };
        },
        setScenarioResult(state, action) {
            const { scenarioId, result } = action.payload;
            state.executionState.results[scenarioId] = result;
        },
        resetExecutionState(state) {
            state.executionState.isRunning = false;
            state.executionState.isCancelled = false;
            state.executionState.currentScenarioId = null;
        },

        // --- APIモックのCRUD ---
        addMock(state, action) {
            state.mocks.push(action.payload);
        },
        updateMock(state, action) {
            const index = state.mocks.findIndex(m => m.id === action.payload.id);
            if (index !== -1) {
                state.mocks[index] = action.payload;
            }
        },
        deleteMock(state, action) {
            // Immerにおける確実な配列要素の削除 (spliceを使用)
            const index = state.mocks.findIndex(m => m.id === action.payload);
            if (index !== -1) {
                state.mocks.splice(index, 1);
            }
        },

        // --- シナリオのCRUD ---
        addScenario(state, action) {
            state.scenarios.push(action.payload);
        },
        updateScenario(state, action) {
            const index = state.scenarios.findIndex(s => s.id === action.payload.id);
            if (index !== -1) {
                state.scenarios[index] = action.payload;
            }
        },
        deleteScenario(state, action) {
            const index = state.scenarios.findIndex(s => s.id === action.payload);
            if (index !== -1) {
                state.scenarios.splice(index, 1);
            }
            if (state.executionState.results[action.payload]) {
                delete state.executionState.results[action.payload];
            }
        },
        toggleScenarioLock(state, action) {
            const scenario = state.scenarios.find(s => s.id === action.payload);
            if (scenario) {
                scenario.locked = !scenario.locked;
            }
        }
    }
});

export const {
    loadTestData, toggleMockEnabled, setExecutionState, setScenarioResult, resetExecutionState,
    addMock, updateMock, deleteMock,
    addScenario, updateScenario, deleteScenario, toggleScenarioLock
} = testItemSlice.actions;

export default testItemSlice.reducer;